import React from 'react';
import useElapsedSeconds, { formatElapsed } from '../../hooks/useElapsedSeconds';
import { SLOW_THINKING_TOOLS, SLOW_TOOL_HINT_THRESHOLD_SECONDS } from '../../lib/slowThinkingTools';
import styles from './BagelChatWidget.module.scss';

interface BagelThinkingIndicatorProps {
  text?: string;
  /** Raw tool name (e.g. "deploy_website") — used only to decide when to show the
   *  "this can take a while" reassurance for tools known to run long. */
  tool?: string;
  /** true while the tool is still running; false once the response arrived */
  isActive?: boolean;
}

export default function BagelThinkingIndicator({
  text,
  tool,
  isActive = false,
}: BagelThinkingIndicatorProps) {
  const elapsed = useElapsedSeconds(text, isActive);
  const showElapsed = isActive && elapsed >= 3;
  const showSlowHint =
    isActive && tool && SLOW_THINKING_TOOLS.has(tool) && elapsed >= SLOW_TOOL_HINT_THRESHOLD_SECONDS;

  return (
    <div className={styles.thinkingIndicator} aria-live="polite">
      {isActive ? (
        <span className={styles.thinkingSpinner} aria-hidden />
      ) : (
        <span className={styles.thinkingDone} aria-hidden>
          ✓
        </span>
      )}
      <span>
        {text || 'Working…'}
        {showElapsed && <span className={styles.thinkingElapsed}> ({formatElapsed(elapsed)})</span>}
        {showSlowHint && (
          <span className={styles.thinkingHint}> — this can take up to ~2 minutes, still working</span>
        )}
      </span>
    </div>
  );
}
